module.exports = __webpack_public_path__ + "static/media/69.d8968f0e.png";